import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';
import Alert from 'react-s-alert';

import { ListItem } from '../../components/ListItem';
import { ModalComponent } from '../../components/Modal';
import { UserEdit } from '../../components/UserEdit';

import { handleFetchAllUsers, adminUpdateUser, adminDeleteUser } from '../../actions/users';
import { deleteConfirm } from '../../services/deleteConfirm';
import { sortUsers } from '../../services/sortUsers';

class Admin extends Component {
  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.state = {
      selected: [],
      openModal: false,
    };
  }
  componentDidMount() {
    const { error } = this.props.user;
    if (error) {
      Alert.error(error, {timeout: 2000});
    }
    this.props.handleFetchAllUsers();
  }

  componentDidUpdate() {
    const { error } = this.props.user;
    if (error) {
      Alert.error(error, {timeout: 2000});
    }
  }

  handleSelect(e) {
    this.setState({
      selected: this.props.user.allUsers.filter((item) => item.id.toString() === e.target.id),
      openModal: true,
    });
  }

  handleSubmit(user) {
    const { adminUpdateUser } = this.props;
    const { selected } = this.state;

    if (selected.length) {
      adminUpdateUser({
        id: this.state.selected[0].id,
        username: user.username,
        admin: user.admin,
        email: user.email,
        company: this.props.user.company,
      });
    }
    this.hideModal();
  }

  handleDelete(id) {
    if (id) {
      this.props.adminDeleteUser(id);
      this.hideModal();
    } else {
      Alert.error('Error ocured! Please try again!', {timeout: 2000});
    }
  }

  hideModal() {
    this.setState({
      selected: [],
      openModal: false,
    });
  }

  render() {
    const { selected, openModal } = this.state;
    const { user } = this.props;

    if (!user.admin) {
      Alert.warning('You dont have permission for this page', {timeout: 2000});
      return <Redirect to="/" />;
    }

    return (
      <div>
        <ModalComponent
          handleHide={this.hideModal}
          open={openModal}
          title="CREATE NEW USER"
        >
          <h3>
            Edit user:
          </h3>
          <UserEdit
            new={false}
            onDelete={(id) => deleteConfirm((() => this.handleDelete(id)))} // eslint-disable-line
            onSubmit={this.handleSubmit}
            user={selected.length ? selected[0] : {}}
          />
        </ModalComponent>
        <ListItem
          columns={['username', 'email', 'admin']}
          header
          onSelect={() => null} // eslint-disable-line
        >
          {{username: 'USERNAME', email: 'EMAIL', admin: 'ADMIN'}}
        </ListItem>
        {user.allUsers && user.allUsers.sort(sortUsers).map((item) => (
          <ListItem
            columns={['username', 'email', 'admin']}
            key={item.id}
            onSelect={this.handleSelect}
          >
            {item}
          </ListItem>
        ))}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.users,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    handleFetchAllUsers,
    adminDeleteUser,
    adminUpdateUser,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Admin);



// WEBPACK FOOTER //
// ./src/containers/Admin/content.js